import {Controller} from '@hotwired/stimulus';
import $ from 'jquery';
import {useModal} from '../js/stimulus_use/use-modal';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'litigantName',
        'recapDate',
        'recapStart',
        'recapEnd',
        'recapMedium',
        'message',
    ];

    static outlets = [
        'attachment-staging',
    ];

    static values = {
        bookingId: Number,
    };

    // The booking's current slot, kept from the view payload. Accepting doesn't change it,
    // but app_booking_edit reads date/start/end/medium up front, so they have to be sent.
    slot = {};

    connect() {
        useModal(this);
    }

    // Loads the requested appointment into the recap block, then opens the modal.
    // Called by accept-booking-link once it has set bookingIdValue on this outlet.
    showContent() {
        showPreloader();

        $.get(routes['app_booking_view'].replace('__id__', this.bookingIdValue), response => {
            this.litigantNameTargets.forEach(element => {
                element.textContent = response.name;
            });

            this.recapDateTarget.textContent = response.date_label;
            this.recapStartTarget.textContent = response.start_label;
            this.recapEndTarget.textContent = response.end_label;
            this.recapMediumTarget.textContent = response.medium_label;

            // Raw values, already in the Y-m-d / H:i shape app_booking_edit parses.
            this.slot = {
                date: response.date,
                start: response.start,
                end: response.end,
                medium: response.medium,
            };

            this.messageTarget.value = '';

            if (this.hasAttachmentStagingOutlet) {
                this.attachmentStagingOutlet.clear();
            }

            this.open();
        }).fail(() => {
            addAlert('danger', translations['profile.An unknown error occurred.']);
        }).always(() => {
            hidePreloader();
        });
    }

    submit(event) {
        if (event) {
            event.preventDefault();
        }

        // The modal only opens through showContent(), which fills the slot; guard anyway so a
        // stray submit can't post the string "undefined" as the date.
        if (!this.slot.date) {
            return;
        }

        showPreloader();

        // Multipart so the staged files ride along with the fields; the fields still land in
        // $request->request and the files under $request->files->all('document') server-side.
        const formData = new FormData();
        formData.append('action', 'accept');
        formData.append('message', this.messageTarget.value);
        // The slot is unchanged on accept, but the endpoint requires these fields.
        formData.append('date', this.slot.date);
        formData.append('start', this.slot.start);
        formData.append('end', this.slot.end);
        formData.append('medium', this.slot.medium);

        if (this.hasAttachmentStagingOutlet) {
            this.attachmentStagingOutlet.getFiles().forEach(file => {
                formData.append('document[]', file);
            });
        }

        $.ajax({
            type: 'POST',
            url: routes['app_booking_edit'].replace('__id__', this.bookingIdValue),
            data: formData,
            processData: false,
            contentType: false,
        }).done(response => {
            if (response.status) {
                this.close();
                // Rebuilds the chat, which also clears the preloader.
                reloadChatAndUserInformation();
            } else {
                addAlert('danger', response.message || translations['profile.An unknown error occurred.']);

                hidePreloader();
            }
        }).fail(() => {
            addAlert('danger', translations['profile.An unknown error occurred.']);

            hidePreloader();
        });
    }
}
